// extracted by mini-css-extract-plugin
module.exports = {"ldsDualRing":"style_ldsDualRing__fn0_Q","lds-dual-ring":"style_lds-dual-ring__9fPNI"};